import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  DEFAULT_PAGE_SIZE,
  parseVehicleListQuery,
  serializeVehicleListQuery,
} from './vehicleListQuery';

const RESET_PAGE_KEYS = ['search', 'site', 'group', 'active', 'tyre_management_enabled', 'ordering', 'page_size'];

const useVehicleListQuery = () => {
  const history = useHistory();
  const location = useLocation();
  const query = useMemo(() => parseVehicleListQuery(location.search), [location.search]);

  const setQuery = useCallback((patch) => {
    const next = { ...query, ...patch };
    if (RESET_PAGE_KEYS.some((key) => Object.prototype.hasOwnProperty.call(patch, key))) {
      next.page = patch.page || 1;
    }
    if (!next.page_size) next.page_size = DEFAULT_PAGE_SIZE;
    const search = serializeVehicleListQuery(next);
    history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' });
  }, [history, location.pathname, query]);

  const clearFilters = useCallback(() => {
    setQuery({
      site: '',
      group: '',
      active: null,
      tyre_management_enabled: null,
    });
  }, [setQuery]);

  const clearAll = useCallback(() => {
    setQuery({
      search: '',
      site: '',
      group: '',
      active: null,
      tyre_management_enabled: null,
    });
  }, [setQuery]);

  return {
    query,
    setQuery,
    clearFilters,
    clearAll,
  };
};

export default useVehicleListQuery;
